import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

// Adds a single holiday; reuses the map component's "datasabt" group for the date.
@Component({
  selector: 'add-holiday-modal',
  templateUrl: './add-holiday-modal.component.html',
})
export class AddHolidayModalComponent {
  @Input() form: FormGroup;

  @Output() saved = new EventEmitter<void>();
}
